import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, reactive } from 'vue'
import { message as DcMessage } from '@dc-platform/dc-components'
import { updateAppVersion } from '@/api/systemSetting/index'
import type { AppVersionItem } from '@/typings/api/systemSetting'


const __default__ = { name: 'ModalForm' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  emits: ['fetch'],
  setup(__props, { expose: __expose, emit: __emit }) {

const formRef = ref()
const visible = ref<boolean>(false)
const loading = ref<boolean>(false)
const dataForm = ref<AppVersionItem>({})
const formRules = reactive({
  input: [{ required: true, message: '请输入' }],
  select: [{ required: true, message: '请选择' }]
})
const emit = __emit
// 弹窗标题
const init = (rows: AppVersionItem) => {
  dataForm.value = {
    ...rows
  }
  visible.value = true
}

const handleOk = () => {
  formRef.value?.validate().then(async () => {
    loading.value = true
    try {
      await updateAppVersion(dataForm.value)
      DcMessage.success('操作成功！')
      emit('fetch')
      handleCancel()
    } finally {
      loading.value = false
    }
  })
}
const handleCancel = () => {
  formRef.value?.resetFields()
  visible.value = false
}

__expose({ init })

return (_ctx: any,_cache: any) => {
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_CosInput = _resolveComponent("CosInput")!
  const _component_CosInputNumber = _resolveComponent("CosInputNumber")!
  const _component_CosTextarea = _resolveComponent("CosTextarea")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_cos_modal = _resolveComponent("cos-modal")!

  return (_openBlock(), _createBlock(_component_cos_modal, {
    visible: visible.value,
    "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((visible).value = $event)),
    width: 600,
    title: "编辑",
    confirmLoading: loading.value,
    destroyOnClose: "",
    onOk: handleOk,
    onCancel: handleCancel
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_form, {
        "wrapper-col": { span: 24 },
        ref_key: "formRef",
        ref: formRef,
        model: dataForm.value
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_form_item, {
            label: "操作系统",
            name: "osType",
            rules: formRules.select
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_select, {
                value: dataForm.value.osType,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((dataForm.value.osType) = $event)),
                options: _ctx.mapsEnum,
                disabled: ""
              }, null, 8, ["value", "options"])
            ]),
            _: 1
          }, 8, ["rules"]),
          _createVNode(_component_a_form_item, {
            label: "当前版本",
            name: "currVersion",
            rules: formRules.input
          }, {
            default: _withCtx(() => [
              _createVNode(_component_CosInput, {
                value: dataForm.value.currVersion,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((dataForm.value.currVersion) = $event)),
                placeholder: "请输入",
                maxlength: 100
              }, null, 8, ["value"])
            ]),
            _: 1
          }, 8, ["rules"]),
          _createVNode(_component_a_form_item, {
            label: "最小版本号",
            name: "minVersion",
            rules: formRules.input
          }, {
            default: _withCtx(() => [
              _createVNode(_component_CosInputNumber, {
                value: dataForm.value.minVersion,
                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((dataForm.value.minVersion) = $event)),
                placeholder: "请输入",
                max: dataForm.value.maxVersion,
                maxlength: 100
              }, null, 8, ["value", "max"])
            ]),
            _: 1
          }, 8, ["rules"]),
          _createVNode(_component_a_form_item, {
            label: "最大版本号",
            name: "maxVersion",
            rules: formRules.input
          }, {
            default: _withCtx(() => [
              _createVNode(_component_CosInputNumber, {
                value: dataForm.value.maxVersion,
                "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((dataForm.value.maxVersion) = $event)),
                placeholder: "请输入",
                maxlength: 100
              }, null, 8, ["value"])
            ]),
            _: 1
          }, 8, ["rules"]),
          _createVNode(_component_a_form_item, {
            label: "升级内容",
            name: "content",
            rules: formRules.input
          }, {
            default: _withCtx(() => [
              _createVNode(_component_CosTextarea, {
                value: dataForm.value.content,
                "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((dataForm.value.content) = $event)),
                placeholder: "请输入",
                maxlength: 100
              }, null, 8, ["value"])
            ]),
            _: 1
          }, 8, ["rules"])
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    _: 1
  }, 8, ["visible", "confirmLoading"]))
}
}

})